import React from 'react';
import PropTypes from 'prop-types';
import { useStyles } from './styles';
import { Link } from 'react-router-dom';

import { useTranslations } from 'components/utilities';

const AirportItem = ({ airport }) => {
	const classes = useStyles();

	const {
		i18n: { language }
	} = useTranslations();

	const name = airport.city[language];


	return (
		<Link to={`/cars/${airport.uuid}`} className={classes.link}>
			<div className={classes.card}>
				<div className={classes.imgContainer}>
					<img
						className={classes.img}
						src={airport.logo.file_path}
						alt={name}
					/>
				</div>
				<div className={classes.nameContainer}>
					<span className={classes.name}>{name}</span>
				</div>
			</div>
		</Link>
	);
};

AirportItem.propTypes = {
	airport: PropTypes.object
};

export default AirportItem;
